import { Autocomplete, Button, Grid, TextField  } from '@mui/material';
import { useEffect, useState } from 'react';

import { gridSizeMdLg12, gridSizeMdLg6, hasPermission } from '@/shared';
import {
  getRadiusRadReply,
  modificarClienteBras,
  SingleRadiusObject,
  usePostReactivarClienteBras,
} from '@/shared/actions/erp';
import {
  CustomTextFieldNoForm,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import TrazabilidadLogFormTab from '@/erp/clientes/fibra-optica/shared/components/form/trazabilidad-log/TrazabailidadLogFormTab';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { queryClient } from '@/shared/query-client/query-client';
import { PermissionsEnum } from '@/auth/interfaces';
import { useDominiosHuawei } from '@/shared/hooks/useDominiosHuawei';
export type DetallesRadReplyModalProps = {
  open: boolean;
  onClose: () => void;
  username: string
  password: string
};

interface FormData {
  old_username?:string,
  username?:string,
  password?:string,
  ipv4?:string
}


const DetallesRadReplyModal: React.FC<
  DetallesRadReplyModalProps
> = ({ onClose, open, username, password="" }) => {

  const canEditUserPass = hasPermission(PermissionsEnum.editar_datos_radius_cliente)
  ///* hooks ------------------------
  const [dataRadReply, setdataRadReply] = useState<SingleRadiusObject[]|null>(null);
  const ipReply = dataRadReply?.find(item => item.attribute === 'Framed-IP-Address');
  const domainReply = dataRadReply?.find(item => item.attribute === 'Huawei-Domain-Name');
  const [domainSearch, setDomainSearch] = useState('');
  /**
   * Opciones de Huawei-Domain-Name: salen del parámetro del sistema
   * DOMINIOS_HUAWEI_RADIUS, no de una lista fija en el código. Si el parámetro
   * falta, el hook devuelve los de siempre y nada cambia.
   */
  const { dominios: dominiosHuawei, cargando: cargandoDominios } = useDominiosHuawei();
  const [formData, setFormData] = useState< FormData| null>(null);
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const { mutateAsync: reactivarClienteBras } = usePostReactivarClienteBras();
  let canUpdate = !!username && open && (
    username!=formData?.username
    || password != formData?.password
    || ipReply?.value != formData?.ipv4
  );
  ///* global state ------------------------
  // const setAlert = useUiStore(s => s.setAlert);

  ///* handlers ------------------------

  const handleClose = () => {
    setdataRadReply(null)
    onClose();
  };
  const radReply = async(username_to_find:string) => {
    const dataRadReply = await getRadiusRadReply({username:username_to_find})
    const dataDomainRadReply: SingleRadiusObject[] =  dataRadReply?.data
    const ip = dataDomainRadReply?.find(item => item.attribute === 'Framed-IP-Address');
    setdataRadReply(dataDomainRadReply)
    
    setFormData({
      old_username: username,
      username: username,
      password: password || "",
      ipv4: ip?.value || ""
    })
  }

  ///* effects ------------------------
  useEffect(() => {
    setDomainSearch('');
    if(!!username && open){
      radReply(username)
    }else{
      setdataRadReply(null)
      setFormData(null)
    }
  }, [username, open]);

  if (!open) return null;

  return (
    <ScrollableDialogProps
      open={open}
      title={`Detalles Radius Reply`}
      minWidth="70%"
      contentNode={
        <Grid
          item
          xs={12}
          container
          spacing={3}
          mt={2}
          alignItems="center"
          pb={5}
        >
          <CustomTextFieldNoForm
            label="ID Framed-IP-Address"
            value={ipReply?.id}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="ID Huawei-Domain-Name"
            value={domainReply?.id}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          {/* <CustomTextFieldNoForm
            label="Attribute"
            value={dataRadReply?.attribute}
            shrink
            disabled
            size={gridSizeMdLg6}
          /> */}
          <CustomTextFieldNoForm
            label="OP"
            value={ipReply?.op}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <Grid container item {...gridSizeMdLg6} spacing={2}>
            <CustomTextFieldNoForm
              label="Huawei-Domain-Name Value"
              value={domainReply?.value}
              shrink
              disabled
              size={gridSizeMdLg6}
            />
            <Grid item {...gridSizeMdLg6}>
              <Autocomplete
                options={dominiosHuawei.filter(value => value !== 'suspendido')}
                loading={cargandoDominios}
                value={null}
                inputValue={domainSearch}
                onInputChange={(_, input, reason) => {
                  setDomainSearch(reason === 'input' ? input : '');
                }}
                onChange={(_, newValue) => {
                  setDomainSearch('');
                  if (!newValue) {
                    return
                  };
                  setConfirmDialog({
                    isOpen: true,
                    title: "Cambiar valor",
                    subtitle:
                      "¿Está seguro que desea cambiar el valor de este registro?",
                    onConfirm: () => {
                      setIsGlobalLoading(true)
                      setConfirmDialogIsOpen(false);
                      reactivarClienteBras({
                        data: {
                          pppoe: username,
                          ip: ipReply?.value || "",
                          value: newValue
                        }
                      },{
                        onSuccess:()=>{
                          if(!!username && open){
                            radReply(username)
                          }
                        },
                        onSettled:()=>{
                          setIsGlobalLoading(false)
                        }
                      })
                    },
                  });
                }}
                renderInput={(params) => <TextField {...params} label="Cambiar Valor" />}
              />
            </Grid>
          </Grid>
          <Grid {...gridSizeMdLg12} item container spacing={2}>
            <TabTextLabel
              text="Datos Modificables del Cliente"
            />
            <CustomTextFieldNoForm
              label="Username"
              value={formData?.username || ""}
              onChangeCustom={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  username: e.target.value,
                }));
              }}
              shrink
              size={gridSizeMdLg6}
              disabled={!canEditUserPass}
            />
            <CustomTextFieldNoForm
              label="Password"
              value={formData?.password || ""}
              onChangeCustom={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  password: e.target.value,
                }));
              }}
              shrink
              size={gridSizeMdLg6}
              disabled={!canEditUserPass}
            />
            <CustomTextFieldNoForm
              label="IPv4"
              value={formData?.ipv4 || ""}
              onChangeCustom={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  ipv4: e.target.value,
                }));
              }}
              shrink
              size={gridSizeMdLg6}
              disabled={!canEditUserPass}
            />
            {
              canUpdate && canEditUserPass &&
              <Grid item {...gridSizeMdLg6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={async() => {
                    const dataToUpdate: any = {
                      old_username: username
                    }
                    if ( formData?.username && formData?.username !== username) {
                      dataToUpdate.username = formData?.username
                    }
                    if (formData?.password && formData?.password !== password) {
                      dataToUpdate.password = formData?.password
                    }
                    if (formData?.ipv4 && formData?.ipv4 !== ipReply?.value) {
                      dataToUpdate.ipv4 = formData?.ipv4
                    }
                    if(Object.keys(dataToUpdate).length > 1){
                      setIsGlobalLoading(true)
                      try {
                        await modificarClienteBras(dataToUpdate);
                        queryClient.invalidateQueries({ queryKey: ['rad-check'] });
                        handleClose();
                      } catch {
                        return;
                      } finally {
                        setIsGlobalLoading(false)
                      }
                      
                    }
                  }}
                >
                  Actualizar
                </Button>
              </Grid>
            }
          </Grid>
          <Grid container item {...gridSizeMdLg12}>
            <TrazabilidadLogFormTab
              contract={{pppoe:username||dataRadReply?.[0]?.username}}
            />
          </Grid>
        </Grid>
      }
      onClose={handleClose}
      showConfirmBtn={false}
    />
  );
};

export default DetallesRadReplyModal;
